import "core-js/modules/es.array.push.js";
import { convertControl, convertXType, getModel, fetchSchemas, saveSchema, deleteSchema } from '@/emap-utils';
import DEFAULT_SETTINGS from './defaultSettings';
import { parseSchema } from './utils';
export default class EmapPlugin {
  constructor(options) {
    this.settings = Object.assign({}, DEFAULT_SETTINGS, options);
  }

  install(ctx) {
    const self = this;
    const {
      settings
    } = self; // 自定义列定义查询

    ctx.plugin('fetch-meta', async (vm, columns, cb) => {
      const {
        pagePath,
        action: actionId,
        params,
        datamodel
      } = settings;

      if (datamodel) {
        return datamodel;
      }

      try {
        const model = await getModel({
          pagePath,
          actionId,
          type: 'search',
          params
        });

        if (model) {
          this.dataUrl = model.url;
          const metas = model.controls.filter(item => !item.hidden && !item['search.hidden']).map(item => {
            const newItem = { ...item,
              label: item.caption,
              prop: item.name,
              fixed: !!item['grid.fixed'] || item.fixed,
              width: item['grid.width'] || item.width
            };
            let jsonParam = item['form.JSONParam'];

            if (jsonParam) {
              try {
                jsonParam = JSON.parse(jsonParam);

                if (jsonParam.sortable) {
                  newItem.sortable = 'custom';
                }
              } catch (e) {
                console.warn('emap parse error, invalid JSONParam', jsonParam);
              }
            }

            return newItem;
          });
          cb(metas); // vm.$emit('model-change', model)
        } else {
          cb(null);
        }
      } catch (e) {
        console.error(e);
        cb(null);
      }
    }); // 转换 Emap 列定义格式

    ctx.plugin('format-controls', (vm, controls) => {
      if (!controls) {
        return [];
      }

      try {
        const result = convertControl(controls, {
          defaultXtype: ''
        }).map(item => {
          const searchXtype = item.options['search.xtype']; // 范围参数调整

          if (searchXtype === 'date-range') {
            item.options.format = item.options.format || 'yyyy-MM-dd';
            const hasTime = item.options.format.indexOf('H') > -1;
            item.options.type = hasTime ? 'datetimerange' : 'daterange';
            item.options['search.xtype'] = hasTime ? 'date-time-picker' : 'date-picker';
            item.options.range = true;
          } else if (searchXtype === 'number-range') {
            item.dataType = 'Array';
            item.options.range = true;
          } else {
            item.options['search.xtype'] = convertXType(searchXtype);
          }

          item.options.builder = item.options.defaultBuilder;

          if (item.options['search.JSONParam']) {
            try {
              const params = JSON.parse(item.options['search.JSONParam']);

              if (params.optionData && Array.isArray(params.optionData)) {
                item.options.options = params.optionData;
              }
            } catch (e) {
              console.error(e);
            }
          }

          return item;
        });

        if (vm.controls) {
          result.push(...vm.controls);
        }

        return result;
      } catch (e) {
        console.error('emap 格式解析失败', e.message);
      }

      return null;
    }); // 转换对外提供的搜索条件格式

    ctx.plugin('post-value', (vm, value) => {
      if (!value) {
        return value;
      }

      value = parseSchema(value);
      return Array.isArray(value) ? value : [value];
    }); // 查询搜索方案列表

    ctx.plugin('fetch-schemas', async (vm, value, cb) => {
      const {
        schemaUrl,
        schemaType,
        pageFlag
      } = this.settings;
      let result = [];

      try {
        result = await fetchSchemas(schemaUrl, {
          schemaType,
          pageFlag
        });
      } catch (e) {
        console.error(e);
      }

      cb((result || []).map(item => ({
        name: item.schemaName,
        type: item.schemaType,
        isFixed: !!item.fixed,
        data: JSON.parse(item.condition)
      })));
    }); // 保存方案

    ctx.plugin('save-schema', async (vm, params, cb) => {
      const {
        schemaSaveUrl,
        schemaType,
        pageFlag
      } = this.settings;
      const {
        isFixed,
        name,
        data
      } = params;
      let result = [];

      try {
        result = await saveSchema(schemaSaveUrl, {
          schemaType,
          pageFlag,
          fixed: +isFixed,
          schemaName: name,
          condition: JSON.stringify(data)
        });
      } catch (e) {
        console.error(e);
      }

      cb(result);
    }); // 删除方案

    ctx.plugin('del-schema', async (vm, item, cb) => {
      const {
        schemaDelUrl,
        schemaType,
        pageFlag
      } = this.settings;
      const {
        name
      } = item;
      let result = null;

      try {
        result = await deleteSchema(schemaDelUrl, {
          schemaType,
          pageFlag,
          schemaName: name
        });
      } catch (e) {
        console.error(e);
      }

      cb(result);
    });
  }

}